const KEY = "ajp_active_plan_v1";
const TTL_MS = 30 * 60 * 1000;

export function saveAjpPlanSession({ journeyId, airportCode, form, planResponse = null, path = window.location.pathname }) {
  if (!journeyId || typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ journeyId, airportCode, form, planResponse, path, savedAt: Date.now(), expiresAt: Date.now() + TTL_MS }));
  } catch (_) { /* Storage can be unavailable in private browser modes. */ }
}

export function readAjpPlanSession(airportCode = null) {
  if (typeof window === "undefined") return null;
  try {
    const value = JSON.parse(window.sessionStorage.getItem(KEY) || "null");
    if (!value || value.expiresAt <= Date.now() || (airportCode && value.airportCode !== airportCode)) {
      if (value?.expiresAt <= Date.now()) window.sessionStorage.removeItem(KEY);
      return null;
    }
    return value;
  } catch (_) { return null; }
}

export function restoredPlanPayload(session) {
  return {
    success: true,
    restored: true,
    data: {
      journey_id: session.journey_id,
      ui_projection: session.comparison_snapshot || {},
    },
  };
}
